<template>
  <div
    class="card shadow"
    :class="type === 'dark' ? 'bg-default' : ''"
    style="min-height: 65vh"
  >
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h3>
        </div>
        <div class="col text-right">
          <input
            type="file"
            accept=".json"
            ref="jsonSelector"
            style="display: none"
            @change="onFileSelect"
          />
          <base-button
            type="primary"
            size="sm"
            @click="selectFile"
            :disabled="files.length == 3"
            class="px-3"
          >
            <div class="d-flex justify-content-end align-items-center">
              <span class="mr-2">Upload File</span>
              <span
                class="ni ni-cloud-upload-96"
                style="font-size: 22px"
              ></span>
            </div>
          </base-button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="files"
      >
        <template slot="columns">
          <th>Files</th>
          <th>Created At</th>
          <th>Action</th>
          <th></th>
        </template>

        <template slot-scope="{ row }">
          <th scope="row">
            <div class="media align-items-center">
              <a
                class="mr-3 cursor_pointer"
                style="max-width: 5%"
                @click.prevent
              >
                <img
                  alt="Image placeholder"
                  src="img/theme/json-file.webp"
                  width="100%"
                />
              </a>
              <div class="media-body">
                <span class="name mb-0 text-sm">{{ row.fileName }}</span>
              </div>
            </div>
          </th>
          <td class="budget">
            {{ row.createdAt | moment("ddd - MMM D, YYYY") }}
          </td>
          <td>
            <base-button type="primary" size="sm" class="p-0">
              <a
                class="d-flex justify-content-end align-items-center"
                style="color: #fff; padding: 4px 10px"
                download
                :href="baseURL + 'downloadFile/' + row._id"
              >
                <span class="mr-2">Download</span>
                <span
                  class="ni ni-cloud-download-95"
                  style="font-size: 22px"
                ></span>
              </a>
            </base-button>
            <base-button
              type="success"
              size="sm"
              v-if="
                $store.getters.isFileProcessing.isProcessing &&
                $store.getters.isFileProcessing.file == row._id
              "
            >
              <div class="d-flex justify-content-end align-items-center">
                <span style="font-size: 15px">&#160;</span>
                <div class="lds-dual-ring"></div>
                <span class="ml-2">Running</span>
                <span style="font-size: 15px">&#160;</span>
              </div>
            </base-button>
            <base-button
              type="success"
              size="sm"
              v-else-if="
                $store.getters.isFileProcessing.isProcessing &&
                $store.getters.isFileProcessing.file != row._id
              "
              :disabled="true"
            >
              <div class="d-flex justify-content-end align-items-center">
                <span style="font-size: 15px">&#160;</span>
                <div class="d-flex justify-content-end align-items-center">
                  <span class="mr-1">Run</span>
                  <span class="ni ni-send"></span>
                </div>
                <span style="font-size: 15px">&#160;</span>
              </div>
            </base-button>
            <base-button
              type="success"
              size="sm"
              v-else
              @click="runFileProcessing(row)"
            >
              <div class="d-flex justify-content-end align-items-center">
                <span style="font-size: 15px">&#160;</span>
                <div class="d-flex justify-content-end align-items-center">
                  <span class="mr-1">Run</span>
                  <span class="ni ni-send"></span>
                </div>
                <span style="font-size: 15px">&#160;</span>
              </div>
            </base-button>
            <base-button
              type="danger"
              size="sm"
              :disabled="
                $store.getters.isFileProcessing.isProcessing &&
                $store.getters.isFileProcessing.file == row._id
              "
            >
              <div
                class="d-flex justify-content-end align-items-center"
                v-if="
                  $store.getters.isFileProcessing.isProcessing &&
                  $store.getters.isFileProcessing.file == row._id
                "
              >
                <span class="">Delete</span>
                <span class="ni ni-fat-remove" style="font-size: 22px"></span>
              </div>
              <div
                v-else
                class="d-flex justify-content-end align-items-center"
                @click="deleteFile(row)"
              >
                <span class="">Delete</span>
                <span class="ni ni-fat-remove" style="font-size: 22px"></span>
              </div>
            </base-button>
          </td>
        </template>
      </base-table>
    </div>
    <div
      v-if="!files.length"
      class="no_record text-gray d-flex justify-content-center py-4"
      style="font-size: 14px"
    >
      No Record Found
    </div>
    <div
      v-if="files.length == 3"
      class="no_record text-gray d-flex justify-content-center py-4"
      style="font-size: 14px; text-transform: uppercase"
    >
      Maximum 3 files can be uploaded
    </div>
    <div
      v-if="$store.getters.isFileProcessing.isProcessing"
      class="no_record text-gray d-flex justify-content-center py-4"
      style="font-size: 14px; text-transform: uppercase; font-weight: 600"
    >
      Only one file can be processed for Content Input at one time
    </div>

    <modal
      :show.sync="fileNameModel"
      body-classes="p-0"
      modal-classes="modal-dialog-centered modal-md"
    >
      <template>
        <div class="container pb-3">
          <div class="row">
            <div
              class="col-12 text-center pt-3 px-0"
              style="position: relative"
            >
              <span
                class="ni ni-fat-remove cursor_pointer"
                style="position: absolute; top: 5px; right: 5px"
                @click="closeModal"
              ></span>
              <h2
                class="pb-3"
                style="display: block; border-bottom: 1px solid silver"
              >
                File Name
              </h2>
            </div>
            <div
              v-if="selectedFiles.length"
              class="col-12 px-3 py-3 text-center"
              style="margin-top: 0.5em; background-color: #6dee6ba8"
            >
              <span class="align-items-center" v-if="selectedFiles.length">
                {{ selectedFiles[0].name }}
                <span class="ml-2" style="font-weight: 600; font-size: 12px"
                  >({{ selectedFiles[0].size | parseSize }})</span
                >
              </span>
            </div>
            <div class="col-12 px-0" v-if="uploadPercentage">
              <base-progress
                type="success"
                :height="5"
                :value="uploadPercentage"
              ></base-progress>
            </div>
            <div class="col-12 text-center pt-3" v-if="!uploadPercentage">
              <input
                type="text"
                name="fileName"
                class="form-control"
                style="font-weight: 600; text-transform: capitalize"
                v-model="fileName"
                :class="{ validated: isValidated }"
                @keypress.enter="proceedUpload"
                @keyup="isValidated = false"
                placeholder="Please input file name"
              />
              <span
                v-if="isValidated"
                style="
                  display: block;
                  font-weight: 600;
                  color: red;
                  text-align: left;
                  font-size: 12px;
                  margin-top: 5px;
                "
                >{{validateErr}}</span
              >
            </div>
            <div class="col-12 text-right pt-3" v-if="!uploadPercentage">
              <base-button type="danger" size="sm" @click="proceedUpload">
                <div class="d-flex justify-content-end align-items-center">
                  <span class="mr-1">Proceed</span>
                  <span class="ni ni-send"></span>
                </div>
              </base-button>
            </div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import { baseURL } from "./../../config";
import * as api from "@/apiList";
import axios from "axios";
let user_session = JSON.parse(localStorage.getItem("user-session"));
let token = "";
if (user_session) {
  token = user_session.token;
}
let headers = {
  Authorization: "Bearer " + token,
};
export default {
  name: "files-table",
  props: {
    files: {
      type: Array,
    },
    title: String,
    type: String,
  },
  data() {
    return {
      baseURL: baseURL,
      fileNameModel: false,
      isFileUploading:
        JSON.parse(localStorage.getItem("isFileUploading")) || false,
      selectedFiles: [],
      fileName: null,
      isValidated: false,
      validateErr: 'Please input file name',
      isProceeded: true,
      uploadPercentage: 0,
      progress: "progress-50",
      isFileParsingRunning: this.$store.getters.isFileProcessing,
    };
  },
  methods: {
    async deleteFile(file) {
      this.$confirm({
        title: "Confirmations!",
        message: `Are you sure to delete this file?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm) => {
          if (confirm) {
            // this.$store.dispatch("toggleLoader", true);
            let data = await api.deleteFile(file._id);
            if (!data.response) {
              let fileIndex = this.files.indexOf(
                this.files.find((obj) => obj._id === file._id)
              );
              this.files.splice(fileIndex, 1);
            } else {
              console.log("ERR: ", data.response.data);
              alert("ERR! ", data.response.data);
            }
            this.$store.dispatch("toggleLoader", false);
          }
        },
      });
    },
    async onFileSelect(e) {
      try {
        this.selectedFiles = e.target.files;
        let name = this.selectedFiles[0].name.split(".");
        name.splice(name.length - 1, 1);
        name = name.join(".");
        this.fileName = name;
        this.fileNameModel = true;
      } catch (err) {
        console.log("UPLOADING FILE ERR: ", err);
      }
    },
    async proceedUpload() {
      try {
        if (this.selectedFiles.length && this.fileName) {
          this.isProceeded = true;
          let formData = new FormData();
          formData.append("fileName", this.fileName);
          formData.append("file", this.selectedFiles[0]);
          this.isFileUploading = true;
          localStorage.setItem("isFileUploading", JSON.stringify(true));
          const res = await axios.post(
            `${baseURL}uploadContentFile`,
            formData,
            {
              headers,
              onUploadProgress: function (progressEvent) {
                this.uploadPercentage = parseInt(
                  Math.round((progressEvent.loaded / progressEvent.total) * 100)
                );
              }.bind(this),
            }
          );
          if (!res.response) {
            this.files.push(res.data.data.file);
            this.isProceeded = false;
            this.fileName = "";
            if (this.uploadPercentage == 100) {
              setTimeout(() => {
                this.fileNameModel = false;
                this.uploadPercentage = 0;
              }, 1000);
              this.$refs["jsonSelector"].value = null;
            }
            this.isFileUploading = false;
            localStorage.setItem("isFileUploading", JSON.stringify(false));
          } else {
            this.uploadPercentage = 0;
            alert("ERR1: ", res.data.data);
            this.isFileUploading = false;
            localStorage.setItem("isFileUploading", JSON.stringify(false));
          }
        } else {
          this.uploadPercentage = 0;
          this.isValidated = true;
          this.isFileUploading = false;
          localStorage.setItem("isFileUploading", JSON.stringify(false));
        }
      } catch (err) {
        if(err.message) {
          console.log("ERR2: ", err.message);
          this.validateErr = err.message;
        }
        this.uploadPercentage = 0;
        this.isValidated = true;
        this.isFileUploading = false;
        localStorage.setItem("isFileUploading", JSON.stringify(false));
      }
    },
    async runFileProcessing(file) {
      this.$confirm({
        title: "Confirmations!",
        message: `Are you sure to process this file? Once processed will not be cancelled`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm) => {
          if (confirm) {
            console.log("FILE: ", file);
            this.isFileProcessing = { file: file._id, isProcessing: true };
            this.$store.dispatch("mutateFileProcessing", this.isFileProcessing);
            let data = await api.processFile(file._id);
            if (!data.response) {
              this.checkFileProcessingStatus();
            } else {
              this.$store.dispatch("mutateFileProcessing", {});
              console.log("PROCCESSING ERR: ", data.response.data);
              this.$toast(`${data.response.data.message}`, {
                position: "top-right",
                timeout: 5000,
                type: "error",
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                icon: true,
                rtl: false,
              });
            }
          }
        },
      });
    },
    async checkFileProcessingStatus() {
      let interval = setInterval(async () => {
        let status = await api.checkFileProcessingStatus();
        if (!status.response) {
          console.log("PROCESSING CHECK: ", status.data.message);
          if (status.data.message == "PROCESSING_FINISHED") {
            this.$store.dispatch("mutateFileProcessing", {});
            clearInterval(interval);
            this.$toast("File Processing Completed Successfully!", {
              position: "top-right",
              timeout: 5000,
              type: "info",
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              icon: true,
              rtl: false,
            });
          } else if (status.data.message == "PROCESSING_FAILED") {
            this.$store.dispatch("mutateFileProcessing", {});
            clearInterval(interval);
            this.$toast("File Processing Failed!", {
              position: "top-right",
              timeout: 5000,
              type: "error",
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              icon: true,
              rtl: false,
            });
          } else if (status.data.message == "PROCESSING_NOT_EXISTED") {
            this.$store.dispatch("mutateFileProcessing", {});
            clearInterval(interval);
          }
        } else {
          console.log("ERR: ", status.response.data);
        }
      }, 5000);
    },

    closeModal() {
      if (!this.isFileUploading) {
        this.uploadPercentage = 0;
        this.fileName = null;
        this.selectedFiles = [];
        this.isValidated = false;
        this.$refs["jsonSelector"].value = null;
      }
      this.fileNameModel = false;
    },

    selectFile() {
      if (!this.isFileUploading) {
        this.$refs["jsonSelector"].click();
      } else {
        this.fileNameModel = true;
      }
    },
  },
  filters: {
    parseSize(value) {
      if (value / (1024 * 1024) < 1) {
        value = parseFloat(value / 1000).toFixed(2);
        return value + " KB";
      } else {
        value = parseFloat(value / (1000 * 1000)).toFixed(2);
        return value + " MB";
      }
    },
  },
  mounted() {
    this.isFileParsingRunning = this.$store.getters.isFileProcessing;
  },
};
</script>
<style lang="scss">
table {
  th {
    font-size: 13px;
  }
}
.validated {
  border-color: red !important;
  &::placeholder {
    color: red !important;
  }
}
.progress-wrapper .progress-info .progress-percentage {
  display: none !important;
}

.lds-dual-ring {
  display: inline-block;
  width: 23px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 75%;
  border: 4px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
